import md5 from 'js-md5';

const API_BASE_URL = 'https://chinatravelask.com/xapi';
const API_KEY = 'c1234567890'; 

function generateHeaders(contentType = 'application/json') {
    const randomNum = Math.floor(Math.random() * 10000);
    const timestamp = Math.floor(Date.now() / 1000);
    const signature = md5(`${API_KEY}${randomNum}${timestamp}`);
    
    return {
        'X-API-RD': randomNum,
        'X-API-TS': timestamp,
        'X-API-Sign': signature,
        'Content-Type': contentType
    };
}

export const getRequest = async (endpoint, params = {}) => {
    try {
        const url = new URL(`${API_BASE_URL}${endpoint}`);
        Object.keys(params).forEach(key => 
            url.searchParams.append(key, params[key])
        );

        const response = await fetch(url, {
            method: 'GET',
            headers: generateHeaders()
        });

        return await response.json();
    } catch (error) {
        console.error('GET请求错误:', error);
        throw error;
    }
};

export const postRequest = async (endpoint, data = {}) => {
    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
            method: 'POST',
            headers: generateHeaders(),
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if (!response.ok) {
            // 服务器返回了错误状态码
            const errorMsg = result.error || 'Request failed, please try again later';
            throw new Error(errorMsg);
        }
        return result;
    } catch (error) {
        console.error('POST请求错误:', error);
        throw error;
    }
};

// 上传头像的配置
export const uploadAvatarUrl = `${API_BASE_URL}/upload_avatar`; // 上传头像的URL
export const uploadHeader = generateHeaders("multipart/form-data");